import { createFileRoute } from "@tanstack/react-router";

import { AdminCpq } from "@/features/admin";

/**
 * Admin · Preventivi (CPQ) — configure and publish Ando Engine licence quotes.
 * Gated by the Admin shell (``isPlatformAdmin``); every BE endpoint enforces
 * ``require_platform_admin`` and only superadmins receive costs and margin.
 */
export const Route = createFileRoute("/_authed/_modal/admin/preventivi")({
  component: AdminCpq,
});
